'use strict';

import $ from 'jquery';
import { lib } from '../../common/Library';

/**
 * 業績ニュース検索枠の動作処理
 */
$(function () {
    $('#tp_edit_cond').on('click', function() {
        $('#topix_search').show();
        $('#topix_search_close').hide();
    });

    // 「検索する」リンククリック時
    $('#tp_commit_cond').on('click', function(e) {
        e.preventDefault();
        validateAndSubmit();
    });

    // Enter押下時
    $('#search_condition').on('submit', function(e) {
        if (!validateAndSubmit()) {
            e.preventDefault();
        }
    });

    $('#stock_code2_text').on('click', function() {
        $('#stock_code2').prop('checked', true);
    });
});

/**
 * 自動更新
 * 自動更新が有効で、検索ボックスが非表示の時のみ実行
 */
$(function() {
    setTimeout(function() {
        if ($("#refresh1").prop('checked') === true
        && $("#topix_search").css('display') !== "block") {
            location.reload();
        }
    }, 30000); //30s
});

function validateAndSubmit() {
    const val = lib.toHankaku($('#stock_code2_text').val()).trim();
    const regex = /^([A-Za-z0-9]{1,4})(\s+[A-Za-z0-9]{1,4})*$/u;
    const selected = $('input[name="stock_code"]:checked').val();

    //指定銘柄で検索時にのみ表示
    if (selected === '2') {
        if (val !== '' && !regex.test(val)) {
            lib.jqAlert('指定銘柄エラー', '銘柄コード（英数字4桁）のみ使用できます。');
            return false;
        }
    }

    $('#topix_search').hide();
    $('#topix_search_close').show();
    document.search_condition.submit();
    return true;
}